import type { TypeVideoConfig } from './types';

import { merge } from '../../helper';

import { create } from './create';

// ----------------------------------------------------------------------------

function metadata(config: TypeVideoConfig = {}): HTMLVideoElement {
    // Default Config
    const defConfig: TypeVideoConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (video)
    const elVideo = create({
        merge: defConfig,
        attr: {
            preload: 'metadata',
        },
        fnLoadedMetaData: function (evt: Event): any {
            const elVideo = evt.currentTarget as HTMLVideoElement;

            // Item
            const item = {
                duration: elVideo.duration,
                element: elVideo,
                height: elVideo.videoHeight,
                src: elVideo.src,
                width: elVideo.videoWidth,
            };

            console.log(item);
        },
    });

    // Return
    return elVideo;
}

function demo(config: TypeVideoConfig = {}): HTMLVideoElement {
    // Default Config
    const defConfig: TypeVideoConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (video)
    const elVideo = metadata({
        merge: defConfig,
        controls: true,
        modal: true,
    });

    // Return
    return elVideo;
}

// ----------------------------------------------------------------------------

export { demo, metadata };
